/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { AdresseCompact } from '@mairistem/adresses';
import { Form } from '@mairistem/composants';

import type { Adresse } from '@/types';

interface TabCollectiviteAdresseProps {
  adresse: Adresse;
  error?: string;
  onChange: (
    e: React.SyntheticEvent,
    data: { name: string; value: string },
  ) => void;
}

const TabCollectiviteAdresse = (props: TabCollectiviteAdresseProps) => {
  const { adresse, error, onChange } = props;

  const [detail, setDetail] = React.useState(false);

  const handleAdresseChange = (data) => {
    onChange(null, {
      name: 'adresse',
      value: {
        ...adresse,
        ...data,
        ...(data.commune ? { libelleCommune: data.commune } : {}),
        ...(data.codePostal ? { libelleCodePostal: data.codePostal } : {}),
        ...(data.voie ? { libelleVoie: data.voie } : {}),
      },
    });
  };

  return (
    <Form.Field>
      <AdresseCompact
        detail={detail}
        onDetailClick={() => setDetail((p) => !p)}
        onAdresseChange={handleAdresseChange}
        adresse={{
          ...adresse,
          codePostal: adresse?.libelleCodePostal,
          commune: adresse?.libelleCommune,
          voie: adresse?.libelleVoie,
        }}
        error={!!error}
      />
    </Form.Field>
  );
};

export default TabCollectiviteAdresse;
